var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarMinimalistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3529_14179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.83301C4.59441 1.83301 1.8335 4.59392 1.8335 7.99967C1.8335 11.4054 4.59441 14.1663 8.00016 14.1663C11.4059 14.1663 14.1668 11.4054 14.1668 7.99967C14.1668 4.59392 11.4059 1.83301 8.00016 1.83301ZM0.833496 7.99967C0.833496 4.04163 4.04212 0.833008 8.00016 0.833008C11.9582 0.833008 15.1668 4.04163 15.1668 7.99967C15.1668 11.9577 11.9582 15.1663 8.00016 15.1663C4.04212 15.1663 0.833496 11.9577 0.833496 7.99967ZM8.00016 3.49967C8.27631 3.49967 8.50016 3.72353 8.50016 3.99967V4.21083C9.58712 4.40545 10.5002 5.22208 10.5002 6.33301C10.5002 6.60915 10.2763 6.83301 10.0002 6.83301C9.72402 6.83301 9.50016 6.60915 9.50016 6.33301C9.50016 5.77016 8.91782 5.16634 8.00016 5.16634C7.08251 5.16634 6.50016 5.77016 6.50016 6.33301C6.50016 6.89585 7.08251 7.49967 8.00016 7.49967C9.29165 7.49967 10.5002 8.38824 10.5002 9.66634C10.5002 10.7773 9.58712 11.5939 8.50016 11.7885V11.9997C8.50016 12.2758 8.27631 12.4997 8.00016 12.4997C7.72402 12.4997 7.50016 12.2758 7.50016 11.9997V11.7885C6.41321 11.5939 5.50016 10.7773 5.50016 9.66634C5.50016 9.3902 5.72402 9.16634 6.00016 9.16634C6.27631 9.16634 6.50016 9.3902 6.50016 9.66634C6.50016 10.2292 7.08251 10.833 8.00016 10.833C8.91782 10.833 9.50016 10.2292 9.50016 9.66634C9.50016 9.1035 8.91782 8.49967 8.00016 8.49967C6.70868 8.49967 5.50016 7.61111 5.50016 6.33301C5.50016 5.22208 6.41321 4.40545 7.50016 4.21083V3.99967C7.50016 3.72353 7.72402 3.49967 8.00016 3.49967Z",
    fill: "#FDF4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3529_14179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarMinimalistic);
export default __webpack_public_path__ + "static/media/dollar-minimalistic.a6ad8445f70456418147a4b4fbefe802.svg";
export { ForwardRef as ReactComponent };